import http from './api'

const route = 'app/linhaproducao/'

export default {
  showComparativoFaturamento: (dataInicial, dataFinal, empresas, cidades, areas, vendedores, redes, tokenContrato, dataInicial1, dataFinal1, empresas1, cidades1, areas1, vendedores1, redes1, segmento, segmento1) => {
    return http.post(route + 'showComparativoFaturamento', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresas,
      cidades: cidades,
      areas: areas,
      vendedores: vendedores,
      redes: redes,
      tokenContrato: tokenContrato,
      dataInicial1: dataInicial1,
      dataFinal1: dataFinal1,
      empresas1: empresas1,
      cidades1: cidades1,
      areas1: areas1,
      vendedores1: vendedores1,
      redes1: redes1,
      segmento: segmento,
      segmento1: segmento1,
    })
  },
}
